import React from 'react';
import { Menu, X } from 'lucide-react';
import { ThemeToggle } from '../common';

const Navigation = ({ 
  sections, 
  activeSection, 
  setActiveSection, 
  mobileMenuOpen, 
  setMobileMenuOpen,
  countdown,
  theme,
  onToggleTheme,
  themeMode,
  onEnableAutoTheme,
  onDisableAutoTheme
}) => {
  return (
    <>
      {/* Header with sunset gradient */}
      <header style={{ 
        background: 'linear-gradient(to right, #fb923c, #ec4899, #a855f7)', 
        color: 'white', 
        position: 'sticky', 
        top: 0, 
        zIndex: 50, 
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' 
      }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem' }}>
          <h1 style={{ fontSize: '1.25rem', fontWeight: 'bold', textShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
            🏖️ Cape San Blas 2025 🌅
          </h1>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <ThemeToggle 
              theme={theme} 
              onToggle={onToggleTheme}
              themeMode={themeMode}
              onEnableAuto={onEnableAutoTheme}
              onDisableAuto={onDisableAutoTheme}
            />
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              style={{ 
                background: 'none', 
                border: 'none', 
                color: 'white', 
                cursor: 'pointer'
              }}
              type="button"
              className="lg:hidden"
            >
              {mobileMenuOpen ? <X style={{ width: '24px', height: '24px' }} /> : <Menu style={{ width: '24px', height: '24px' }} />}
            </button>
          </div>
        </div>
        
        {/* Countdown Timer with enhanced animation */}
        {countdown.show && countdown.message && (
          <div className="px-4 pb-3 text-center animate-fade-in">
            {countdown.days > 0 || countdown.hours > 0 || countdown.minutes > 0 ? (
              <div className="text-sm">
                <span className="font-bold text-2xl countdown-number drop-shadow">{countdown.days}</span> days, {' '}
                <span className="font-bold text-2xl countdown-number drop-shadow">{countdown.hours}</span> hours, {' '}
                <span className="font-bold text-2xl countdown-number drop-shadow">{countdown.minutes}</span> minutes
                <div className="text-xs mt-1 opacity-90">{countdown.message}</div>
              </div>
            ) : (
              <div className="text-lg font-bold animate-pulse drop-shadow">{countdown.message}</div>
            )}
          </div>
        )}
        
        {/* Mobile Menu with slide animation */}
        {mobileMenuOpen && (
          <nav className="lg:hidden border-t border-white border-opacity-20 bg-gradient-to-br from-orange-500 via-pink-500 to-purple-600 backdrop-blur-md animate-slide-down">
            {sections.map(section => (
              <button
                key={section.id}
                onClick={() => {
                  setActiveSection(section.id);
                  setMobileMenuOpen(false);
                }}
                className={`w-full px-4 py-3 flex items-center space-x-3 transition-all touch-scale ${
                  activeSection === section.id ? 'bg-white bg-opacity-25' : 'hover:bg-white hover:bg-opacity-15'
                }`}
                type="button"
              >
                <section.icon className="w-5 h-5" />
                <span className="font-medium">{section.label}</span>
              </button>
            ))}
          </nav>
        )}
      </header>

      {/* Desktop Navigation with enhanced styling */}
      <nav className="hidden lg:flex bg-white bg-opacity-90 backdrop-blur-md shadow-md sticky top-16 z-40">
        <div className="max-w-6xl mx-auto flex">
          {sections.map(section => (
            <button
              key={section.id}
              onClick={() => setActiveSection(section.id)}
              className={`px-6 py-4 flex items-center space-x-2 border-b-2 transition-all font-medium ${
                activeSection === section.id
                  ? 'border-orange-500 text-orange-600 bg-orange-50'
                  : 'border-transparent text-gray-600 hover:text-gray-800 hover:bg-orange-50 hover:bg-opacity-50'
              }`}
              type="button"
            >
              <section.icon className="w-5 h-5" />
              <span>{section.label}</span>
            </button>
          ))}
        </div>
      </nav>
    </>
  );
};

export default Navigation;